module.exports = __webpack_public_path__ + "media/application/images/projects/images/northern_ireland-3624504df0797dac03f8dbd0b5511506.jpg";